import { prepUrlFromUIRouter, modernRoutes } from "@shared/svelte/modernRouting";
import * as _ from "lodash";

export function initializeStateService(routifyCommands) {
  window["stateService"] = {
    go: function (stateName, params, extra) {
      if (modernRoutes(stateName)) {
        params = _.pickBy(params, v => v != undefined);
        routifyCommands.$goto(modernRoutes(stateName), params);
        if (extra && extra.reload) {
          setTimeout(() => {
            routifyCommands.$page["reset"]();
          });
        }
      } else {
        window.location.href = prepUrlFromUIRouter(stateName, params, extra);
      }
      return Promise.resolve();
    },
    reload: function () {
      setTimeout(() => {
        routifyCommands.$page.reset();
      });
    },
    href: function (stateName, params, opts) {
      if (modernRoutes(stateName)) {
        return routifyCommands.$url(modernRoutes(stateName), params);
      } else {
        return prepUrlFromUIRouter(stateName, params, opts);
      }
    },
  };
  window["stateService"]["current"] = {};
  window["stateParams"] = {};
}
